/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  CurveLPTokensMagicianETH256,
  CurveLPTokensMagicianETH256Interface,
} from "../CurveLPTokensMagicianETH256";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ICurveLPTokensDetailsFetchersRepository",
        name: "_fetchersRepository",
        type: "address",
      },
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_priceProvidersRepository",
        type: "address",
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nullAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "InvalidCurvePriceProviderLPTokenPair",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidFetchersRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidOrNotSupportedLPToken",
    type: "error",
  },
  {
    inputs: [],
    name: "Unsupported",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "coin",
        type: "address",
      },
    ],
    name: "Cached",
    type: "event",
  },
  {
    inputs: [],
    name: "FETCHERS_REPO",
    outputs: [
      {
        internalType: "contract ICurveLPTokensDetailsFetchersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_COINS",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NULL_ADDRESS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "QUOTE_TOKEN",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "poolCoins",
    outputs: [
      {
        internalType: "address",
        name: "coin",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "index",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pools",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "towardsAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsNative",
    outputs: [
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type CurveLPTokensMagicianETH256ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CurveLPTokensMagicianETH256ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CurveLPTokensMagicianETH256__factory extends ContractFactory {
  constructor(...args: CurveLPTokensMagicianETH256ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "CurveLPTokensMagicianETH256";
  }

  deploy(
    _fetchersRepository: string,
    _priceProvidersRepository: string,
    _weth: string,
    _nullAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CurveLPTokensMagicianETH256> {
    return super.deploy(
      _fetchersRepository,
      _priceProvidersRepository,
      _weth,
      _nullAddress,
      overrides || {}
    ) as Promise<CurveLPTokensMagicianETH256>;
  }
  getDeployTransaction(
    _fetchersRepository: string,
    _priceProvidersRepository: string,
    _weth: string,
    _nullAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _fetchersRepository,
      _priceProvidersRepository,
      _weth,
      _nullAddress,
      overrides || {}
    );
  }
  attach(address: string): CurveLPTokensMagicianETH256 {
    return super.attach(address) as CurveLPTokensMagicianETH256;
  }
  connect(signer: Signer): CurveLPTokensMagicianETH256__factory {
    return super.connect(signer) as CurveLPTokensMagicianETH256__factory;
  }
  static readonly contractName: "CurveLPTokensMagicianETH256";
  public readonly contractName: "CurveLPTokensMagicianETH256";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CurveLPTokensMagicianETH256Interface {
    return new utils.Interface(_abi) as CurveLPTokensMagicianETH256Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurveLPTokensMagicianETH256 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as CurveLPTokensMagicianETH256;
  }
}
